<template>
  <ion-page>
    <ion-header>
      <ion-toolbar>
        <ion-buttons slot="start">
          <ion-back-button default-href="/"></ion-back-button>
        </ion-buttons>
        <ion-title>Contacts</ion-title>
      </ion-toolbar>
    </ion-header>
    <ion-content padding>
      <ion-card>
        <ion-card-header>
          <ion-card-subtitle>Select Contact Type</ion-card-subtitle>
          <ion-card-title>Search</ion-card-title>
        </ion-card-header>

        <ion-card-content>
            <ion-button @click="$router.push({ name: 'covid-contacts' })" expand="full">Covid-19</ion-button>
            <ion-button @click="$router.push({ name: 'province-contacts' })" expand="full">Provincial</ion-button>
            <ion-button @click="$router.push({ name: 'search-contacts' ,params:{search_type:'hospital'}})" expand="full">Hospitals</ion-button>
            <ion-button @click="$router.push({ name: 'search-contacts' })" expand="full">District Directors</ion-button>
            <ion-button @click="$router.push({ name: 'search-contacts' })" expand="full">Hospital CEOs</ion-button>
        </ion-card-content>
      </ion-card>
        
    </ion-content>
  </ion-page>
</template>

<script>
export default {
    name:'contacts'
}
</script>

<style scoped>
ion-toolbar {
  --ion-toolbar-background:#fbc414;
  --ion-text-color:white;
}
ion-back-button{
    --color:white;
}
ion-button{
    --background:#1b9346;
}
</style>